var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getExerciseViewName,{tag:"component",on:{"next":_vm.toNextPage}})}
var staticRenderFns = []

export { render, staticRenderFns }